import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const useLoginFormText = () => {
    const { t } = useTranslation();

    const loginFormText = useMemo(
        () => ({
            text: {
                welcome: t('login.text.welcome'),
                enterPassword: t('login.text.enter_password'),
                requiredEmail: t('login.text.required_email'),
                invalidEmail: t('login.text.invalid_email'),
                requiredPassword: t('login.text.required_password'),
                showPassword: t('login.text.showPassword'),
                newToGivelify: t('login.text.newToGivelify'),
            },
            link: {
                anotherUser: t('login.link.another_user'),
                removeAccount: t('login.link.remove_account'),
                forgotPassword: t('login.link.forgot_password'),
                signUp: t('login.title.signUp'),
            },
            title: {
                email: t('login.title.email'),
                password: t('login.title.password'),
                passwordHolder: t('login.title.password_holder'),
                login: t('login.title.login'),
                signIn: t('login.title.signIn'),
            },
            notRobot: t('labels.notRobot'),
            notVerified: {
                toSignIn: t('login.notVerified.toSignIn'),
                checkEmail: t('login.notVerified.checkEmail'),
                click: t('login.notVerified.click'),
                help: t('login.notVerified.help'),
                link: t('login.notVerified.link'),
            },
        }),
        [t],
    );

    return loginFormText;
};
